import { Link } from '@mui/material';
import React from 'react';
import { getCommonDictionary } from '@/shared/i18n';

const LoginFooter: React.FC = () => {
  const [dict, setDict] = React.useState<any>({});

  React.useEffect(() => {
    const loadDict = async () => {
      const locale = 'it';
      const commonDict = await getCommonDictionary(locale);
      setDict(commonDict.common);
    };
    loadDict();
  }, []);

  return (
    <footer className="flex z-10 justify-center items-center px-6 max-w-full whitespace-nowrap w-[600px] max-md:px-5">
      <nav className="flex gap-5 items-center text-white">
        <Link color="inherit" underline="none">
          {dict.terms || 'Termini'}
        </Link>
        <div className="w-[1px] h-[18px] bg-white block" />
        <Link color="inherit" underline="none">
          {dict.conditions || 'Condizioni'}
        </Link>
      </nav>
    </footer>
  );
};

export default LoginFooter;
